const normalize = (value: string) => value.trim().toLocaleLowerCase();

const scoreValue = (query: string, value: string): number | undefined => {
  const candidate = normalize(value);
  if (candidate.includes(query)) {
    return 0;
  }

  let queryIndex = 0;
  let previousMatch = -1;
  let score = 0;
  for (let candidateIndex = 0; candidateIndex < candidate.length; candidateIndex++) {
    if (candidate[candidateIndex] !== query[queryIndex]) {
      continue;
    }
    score += previousMatch < 0 ? candidateIndex : candidateIndex - previousMatch - 1;
    previousMatch = candidateIndex;
    queryIndex++;
    if (queryIndex === query.length) {
      return score;
    }
  }
  return undefined;
};

export const getFuzzySearchScore = (
  query: string,
  values: readonly string[]
): number | undefined => {
  const normalizedQuery = normalize(query);
  if (!normalizedQuery) {
    return 0;
  }

  const scores = [...values, values.join(" ")]
    .map(value => scoreValue(normalizedQuery, value))
    .filter((score): score is number => score !== undefined);
  const score = scores.length ? Math.min(...scores) : undefined;
  return score !== undefined && score <= Math.max(3, Math.floor(normalizedQuery.length * 0.75))
    ? score
    : undefined;
};
